export default __webpack_public_path__ + "fonts/edu_3.bed07e0f0ec8b2d858d8e64fa263cdaa.png";